import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import {Origin} from "./origins.model";

@Injectable()
export class OriginsService {

	constructor(private http: HttpClient) {}

	public createOrigin(origin: Omit<Origin, 'id'>): Observable<Origin> {
		return this.http.post<Origin>(`/backoffice/origins`, origin);
	}

	public getOriginById(id: string): Observable<Origin> {
		return this.http.get<Origin>(`/backoffice/origins/${id}`);
	}

	public getOrigins(): Observable<Origin[]> {
		return this.http.get<Origin[]>(`/backoffice/origins`);
	}

	public updateOrigin(origin: Origin): Observable<Origin> {
		return this.http.put<Origin>(`/backoffice/origins/${origin.id}`, origin);
	}

	public deleteOrigin(origin: Origin): Observable<any> {
		return this.http.delete(`/backoffice/origins/${origin.id}`);
	}
}
